module.exports = __webpack_public_path__ + "img/pic2.8299352c.png";